const createBusinessCardPayload = (businessName,cardName,businessCard,deletedActions,deletedImages) => {

    const {clientInfo , settings , actions , images} = businessCard;
    // const {actions , ...rest} = settings;
    // const cardSettings = rest;

    const payload = {
        'businessCard':{
            'businessName':businessName,
            'cardname':cardName,
            'clientInfo':clientInfo,
            'settings': settings,
            'actions': actions,
            'images': images
        },
        'deletedActions': deletedActions,
        'deletedImages': deletedImages
    }

    return payload;
}

export default createBusinessCardPayload;